import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { DialogData } from '../start-trial-modal/start-trial-modal.component';

@Component({
  selector: 'app-start-trial-success-modal',
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './start-trial-success-modal.component.html',
  styleUrl: './start-trial-success-modal.component.scss',
})
export class StartTrialSuccessModalComponent {
  public readonly numDaysTrial: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.numDaysTrial = data.numDaysTrial;
  }
}
